import classNames from 'classnames';
import bnbLogo from 'modules/account/assets/bnb.svg';
import { useAccount } from 'modules/account/hooks/useAccount';
// import { truncateWalletAddr } from 'modules/common/utils/truncateWalletAddr';
import UserIcon from './assets/user.svg';
import { Button } from 'modules/uiKit/Button';
import React, { useRef } from 'react';
import { FocusOn } from 'react-focus-on';
import { WalletCard } from '../WalletCard';
import { useWalletDropdown } from './useWalletDropdown';
import { useWalletStyles } from './useWalletStyles';
import { getNativeTokenSymbol } from '../../../common/conts';
import { useWeb3Balance } from 'modules/account/hooks/useWeb3React';
import { Box } from '@material-ui/core';
import SwitchIcon from './assets/switch.svg';
import {getChainConfig } from 'modules/account/hooks/chainConfig';
import {isChainSupported} from 'modules/common/conts';
import { useIsLGDown } from 'modules/themes/useTheme';
// import ConnectIcon from 'modules/layout/components/Header/assets/connectIcon.svg';
interface IWalletProps {
  address?: string;
  name?: string;
}

// TODO: replace with real data
const logo = bnbLogo;

export const WalletComponent = ({
  address = '',
  name = 'Unnamed',
}: IWalletProps) => {
  const classes = useWalletStyles();
  const isMobile = useIsLGDown();
  const { chainId,handleChangeNetworkToSupported } = useAccount();
  const currency = getNativeTokenSymbol(chainId);

  const {
    isOpened,
    handleDisconnect,
    handleClose,
    handleOpen,
  } = useWalletDropdown();

  const controlRef = useRef<HTMLButtonElement>(null);

  const { balance } = useWeb3Balance();

  return (
    <>
      <Box display={'flex'} alignItems={'center'}>
        {/* <img src={ConnectIcon} className={classes.connectIcon} alt="" /> */}
        {isChainSupported.indexOf(chainId) < 0 && <Button className={classes.switch} onClick={()=>{
          handleChangeNetworkToSupported(getChainConfig(isChainSupported[0]).chainConfig)
        }}>{isMobile?"Switch":'Switch Network'}<img src={SwitchIcon} alt="" /></Button>
        }
        <Button
          className={classes.accountBtn}
          onClick={handleOpen}
          onMouseOver={handleOpen}
        >
          <img src={UserIcon} alt="" />
          {address.slice(0,4)+'...'+address.slice(address.length-2)}
        </Button>
      </Box>

      <FocusOn
        enabled={isOpened}
        onEscapeKey={handleClose}
        onClickOutside={handleClose}
        focusLock={true}
        scrollLock={false}
        shards={[controlRef]}
      >
        <div
          className={classNames(
            classes.dropdown,
            isOpened && classes.dropdownActive,
          )}
        >
          <WalletCard
            address={address}
            name={name}
            currency={currency}
            logo={logo}
            balance={balance}
            handleDisconnect={handleDisconnect}
            handleClose={handleClose}
          />
        </div>
      </FocusOn>
    </>
  );
};

export const Wallet = () => {
  const { address } = useAccount();

  // const { data } = useQuery<IProfileInfo | null>({
  //   type: fetchProfileInfo.toString(),
  // });

  return (
    <WalletComponent
      address={address}
      name={""}
    />
  );
};
